
import React, { Component } from 'react';
import {Redirect} from 'react-router-dom' ;
import { connect } from "react-redux";
import SubTitle from 'components/FacilityRequestComponents/ResourceComponents/SubTitle';
import CreateMaintenanceImagesTable  from 'components/FacilityRequestComponents/Maintenance/CreateMaintenanceImagesTable';
// import { CheckIsLogOnNameExists } from 'action/tenantAction';
import {  DeleteAttachment, GetStandardFields, SaveAttachmentToFolder } from 'action/workorderAction';
import {SaveMaintenanceRequest } from 'action/facilitiesAction';
import user_svg from 'Assets/icons/Icons__error.svg';
import { Label } from "reactstrap";
import styles from './maintenance.module.css';
import { setAmplitudeEvent } from 'amplitude/amplitude';

class CreateMaintenance extends Component {
    
    componentWillMount() {
        this.props.GetStandardFields();
    }

    constructor(props) {
        super(props);
        this.state = {
            navigateToMaintenanceList_state: false,
            displayErrorMessages: false,
            description: null,
            attachments: [],
            displayImageError:false,
            errorImageName:null,
            errorImageText:"file type not supported",
        }
        this.submitMaintenanceForm = this.submitMaintenanceForm.bind(this);
        this.textareaValueChange = this.textareaValueChange.bind(this);
        this.deleteAttachment = this.deleteAttachment.bind(this);
        this.navigateToMaintenanceList = this.navigateToMaintenanceList.bind(this);
    }
    navigateToMaintenanceList(){ this.setState({navigateToMaintenanceList_state:true}); } //Updating state to redirect to list page.
    textareaValueChange(){ this.setState({description:this.refs.description.value, displayErrorMessages: false}); } //Updating state to redirect to list page.

    render() {
        let { displayErrorMessages,errorImageName,displayImageError, errorImageText} = this.state;
        let preferredfields = this.props.getWorkorderPreferences;
        let label = this.props.getLabels;
        var description1 = "";

        if(preferredfields !== undefined && preferredfields.length > 0){
            preferredfields.forEach(fields => {
                fields.fieldLabel = (fields.fieldLabel !== "") ? fields.fieldLabel : label['WorkOrderSetup.Options.' + fields.fieldId + '.Text'];
            });
            description1 = preferredfields.filter(x => x.field === "Description" && x.display === true);
        }
        
        //Navigate or redirect to create maintenance page
        if(this.state.navigateToMaintenanceList_state){
            return <Redirect to={{ pathname: '/FacilityManagement/Maintenance' }} />
        }

        return (
            <div>
                <SubTitle text={"Maintenance"} />
                <div className={styles.whiteContainer}>

                    {/* Form Section */}
                    <h3 className={styles.subTitle}>New Maintenance Request</h3>
                    <p className={styles.subTitle_desciption}>Enter a detailed description of your new maintenance request below.</p>
                    <p className={(displayErrorMessages) ? styles.error_formLabel : styles.formLabel}>{(description1.length > 0) ? description1[0].fieldLabel + "*" : "Description*"}</p>
                    <textarea className={(displayErrorMessages) ? styles.error_textarea : styles.textarea} rows="5" ref='description' onChange={this.textareaValueChange} maxLength="1000" ></textarea>
                    <span className={styles.errorspan} style={{ display: (displayErrorMessages) ? 'initial' : 'none' }}><img src={user_svg} alt="Trane Logo" height="25px" width="25px" /></span>  <br />        {/* Error Icon */}
                    <p className={styles.errorMessagge} style={{ display: (displayErrorMessages) ? 'initial' : 'none' }}>An entry is required.</p>      {/* Required Error message */}


                    {/* Documents Section */}
                    <div className={styles.documentsSections}>
                        <p className={styles.documentsformLabel}>Attached Documents or Photos </p>
                        <div className={styles.addButtonContainer}>
                         <Label className="workorderedit-choosebtn" style={{float:'right'}}>
                                <input type="file" id="myfile" onChange={(e) => this._uploadAttachment(e)} />{"ADD"}
                        </Label>
                        </div>

                        <div className={styles.tableContainer}>
                             <CreateMaintenanceImagesTable records={this.state.attachments} onDeleteAttachment={this.deleteAttachment}   display_error={displayImageError} errorImageNames={errorImageName} errorImageTexts={errorImageText} />
                        </div>
                         <p className={styles.attachmentsDetailsText}>Attachments cannot be greater than 10MB. Acceptable formats: DOC, DOCX, JPG or PDF</p>
                        <p className={styles.requiredFieldText}>* required fields.</p>
                    </div>
                </div>

                {/* Submit buttons Section */}
                <div className={styles.buttonsSections}>
                <div className={styles.buttonsSectionsSubContainer}>
                    <div className={styles.errorBoxMessage} style={{ display: (displayErrorMessages) ? 'initial' : 'none' }}><img src={user_svg} alt="Trane Logo" height="25px" width="25px" /> Please correct all errors before continuing.</div>
                    <button className={styles.saveButton} onClick={this.submitMaintenanceForm}>SAVE</button>
                    <button className={styles.cancelButton}  onClick={this.navigateToMaintenanceList}>CANCEL</button>
                    </div>   
                </div>

            </div>
        );
    }


    //Submit maintenance form 
    submitMaintenanceForm() {
        let { description } = this.state;
        let { userProfileDetails,employeeTenantDetails } = this.props;
        let employeeTenantID = employeeTenantDetails.tenantId;
         let userId = userProfileDetails.id;
         var AttachmentsData = [], AttachmentItems = '';

         if (this.state.attachments.length) {
            this.state.attachments.forEach(el => {
                AttachmentItems = {
                    "AttachmentName": el.name,
                    "FileName": el.fileName
                }
                AttachmentsData.push(AttachmentItems);
            });
        }

                
        if (description !== null && description !== "" && userId !==undefined &&  userId !==null) {
            let data = {
                "description" : description,
                "DueDate": '1753/01/01',
                 "workOrderAttachment": (this.state.attachments.length > 0) ? AttachmentsData : null,  
                 "workOrderDetail": {
                    "workOrderDetailID": 0,
                    "tenantID": employeeTenantID,
                     },               
            }
         
            this.props.SaveMaintenanceRequest(data).then((response) => {
                setAmplitudeEvent("Create Work Order",{"Notify Others":0,"Page":'Facility Screen'});
            
            });
            this.setState({navigateToMaintenanceList_state:true});
        }
        else {
            this.setState({ displayErrorMessages: true });
        }
    }


    _uploadAttachment(e) {
        e.preventDefault();

        this.setState({
            displayImageError:false,
            errorImageName:null,
            errorImageText:"file size limit exceeded.",
        });

        var fileTypes = ['doc','docx','jpg','jpeg','png','pdf'];
        if (e.target.files && e.target.files[0]) {
            var extension = e.target.files[0].name.split('.').pop().toLowerCase(),  //file extension from input file
                fileTypeSuccess = fileTypes.indexOf(extension) > -1;  //is extension in acceptable types
                var fileSize = document.getElementById('myfile').files[0].size; //Checking for file size

            if (fileTypeSuccess && fileSize <= 10000000 ) {
                let file = e.target.files[0];
                let reader = new FileReader();
                reader.onloadend = () => {
                    const data = new FormData();
                    data.append('file', file);
                    const l_Request = this.props.SaveAttachmentToFolder(data, 0);
                    l_Request.then((result) => {
                        if (this.props.getUniqueAttachmentName !== undefined && this.props.getUniqueAttachmentName !== null && this.props.getUniqueAttachmentName !== []) {
                            this.setState({ attachments: [...this.state.attachments, { 'id': 0, 'name': file.name, 'fileName': this.props.getUniqueAttachmentName.FileName }] });
                        }
                    });
                }
                reader.readAsDataURL(file)
                e.target.value = null;
            }
            else if(fileSize >= 10000000) { 
                this.setState({
                    displayImageError:true,
                    errorImageName:e.target.files[0].name,
                    errorImageText:"file size limit exceeded.",
                })
            }
            else  { 
                this.setState({
                    displayImageError:true,
                    errorImageName:e.target.files[0].name,
                    errorImageText:"file type not supported.",
                })
            }
        }
    }

    //Delete an Attachment 
    deleteAttachment(record) {
        let lineitem = {
            "AttachmentId": 0,
            "FileName": record,
        }
        this.props.DeleteAttachment(lineitem);
        this.setState({ attachments: this.state.attachments.filter(el => el.fileName !== record) });
    }
}


const mapStateToProps = state => {
    return {
        userProfileDetails: state.userDetailsRootReducer.user_info,
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getWorkorderPreferences: state.WorkorderRootReducer.WorkOrderStandardFields,
        employeeTenantDetails: state.FacilityRequestsEmployeeTenantDetails.EmployeeTenantDetails,
        getUniqueAttachmentName: state.WorkorderRootReducer.UniqueAttachmentName,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetStandardFields : () => dispatch(GetStandardFields()),
        DeleteAttachment: (lineitem) => dispatch(DeleteAttachment(lineitem)),
        SaveMaintenanceRequest: (data) => dispatch(SaveMaintenanceRequest(data)),
        SaveAttachmentToFolder: (file, AttachmentId) => dispatch(SaveAttachmentToFolder(file, AttachmentId)),
        // CheckIsLogOnNameExists: (name) => dispatch(CheckIsLogOnNameExists(name)),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(CreateMaintenance);